export default __webpack_public_path__ + "static/anthony-gerald-peppercloud-customer-f5739f28cec9fd85c3f067950fd969a9.png";